import React from "react";

import {makeStyles} from "@material-ui/core";

import {CATEGORY_DISABLED_INFO} from "../../constants";
import {DisabledReasonTooltip} from "../../../../../components/Tooltip";


const useStyles = makeStyles(() => ({
  tooltip: {
    top: -12,
  }
}))

export const DisabledCategoryTooltipWrapper = ({children, isCreate}) => (
  <DisabledFieldTooltipWrapper title={isCreate && CATEGORY_DISABLED_INFO}>{children}</DisabledFieldTooltipWrapper>
)

const DisabledFieldTooltipWrapper = ({children, title}) => {
  const classes = useStyles();

  return (
    <DisabledReasonTooltip title={title} width={800} classes={classes}>
      {children}
    </DisabledReasonTooltip>
  )
}

export default DisabledFieldTooltipWrapper;